import React, {useCallback, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, positionRelative, pt} from "@pg-design/helpers-css";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal";
import {useMap} from "@pg-mono/hooks";
import {RequestState} from "@pg-mono/request-state";

import {ViewType} from "../../../../view_type/ViewType";
import {OfferSidebar} from "../../../atoms/OfferSidebar";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar, MapOfferSidebar} from "../../../map/components/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const mappedOfferList = useMap(props.offerList);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    useEffect(() => {
        setIsInitialized(true);
    }, []);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    if (!isInitialized) {
        return (
            <div css={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div css={[positionRelative]}>
            <Modal fullScreen isOpen={props.isModalOpen} onModalClose={props.onModalClose} contentStyle={[flex(), flexDirection("column")]}>
                <div css={mapHolderSection}>
                    <Button css={mapModalButton} onClick={props.onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                        Lista
                    </Button>

                    <div css={mapHolder}>
                        <MapSize fullWidth={!currentOfferId}>
                            <OSMapForOffers
                                transportRoutes={transportRoutes}
                                viewType={props.viewType}
                                onMarkerClick={onMarkerClick}
                                offers={props.offerList}
                                favouriteOffers={props.favouriteOffers}
                                appliedOffers={props.appliedOffers}
                            />
                        </MapSize>

                        <OfferSidebar animation={!!currentOfferId} css={elementIndex}>
                            {!!currentOfferId && (
                                <div css={mapOfferSidebarWrapper}>
                                    <MapOfferSidebar
                                        offer={mappedOfferList[currentOfferId]}
                                        onOfferSidebarClose={onOfferSidebarClose}
                                        requestState={RequestState.Success}
                                        latestQuery={{}}
                                    />
                                </div>
                            )}
                        </OfferSidebar>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css`
    ${flexAbsoluteCenter};
    height: 100vh;
`;

const mapHolderSection = css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;

    .gm-style-iw-c {
        ${borderRadius()};
        ${elevation(0)};
        padding-right: 15px !important;
        button {
            top: 3px;
            right: 3px;
            display: none !important;
        }
    }
`;

const mapHolder = css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
`;

const mapModalButton = css`
    position: absolute;
    top: 2.5rem;
    left: 2.5rem;
    z-index: 1;
`;

const elementIndex = css`
    z-index: 1;
`;

const mapOfferSidebarWrapper = css`
    ${pt(2)};
`;
import React, {useCallback, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {elevation} from "@pg-design/elevation";
import {borderRadius, flex, flexAbsoluteCenter, flexDirection, positionRelative, pt} from "@pg-design/helpers-css";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal";
import {useMap} from "@pg-mono/hooks";
import {RequestState} from "@pg-mono/request-state";

import {ViewType} from "../../../../view_type/ViewType";
import {OfferSidebar} from "../../../atoms/OfferSidebar";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar, MapOfferSidebar} from "../../../map/components/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const mappedOfferList = useMap(props.offerList);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    useEffect(() => {
        setIsInitialized(true);
    }, []);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    if (!isInitialized) {
        return (
            <div css={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div css={[positionRelative]}>
            <Modal fullScreen isOpen={props.isModalOpen} onModalClose={props.onModalClose} contentStyle={[flex(), flexDirection("column")]}>
                <div css={mapHolderSection}>
                    <Button css={mapModalButton} onClick={props.onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                        Lista
                    </Button>

                    <div css={mapHolder}>
                        <MapSize fullWidth={!currentOfferId}>
                            <OSMapForOffers
                                transportRoutes={transportRoutes}
                                viewType={props.viewType}
                                onMarkerClick={onMarkerClick}
                                offers={props.offerList}
                                favouriteOffers={props.favouriteOffers}
                                appliedOffers={props.appliedOffers}
                            />
                        </MapSize>

                        <OfferSidebar animation={!!currentOfferId} css={elementIndex}>
                            {!!currentOfferId && (
                                <div css={mapOfferSidebarWrapper}>
                                    <MapOfferSidebar
                                        offer={mappedOfferList[currentOfferId]}
                                        onOfferSidebarClose={onOfferSidebarClose}
                                        requestState={RequestState.Success}
                                        latestQuery={{}}
                                    />
                                </div>
                            )}
                        </OfferSidebar>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css`
    ${flexAbsoluteCenter};
    height: 100vh;
`;

const mapHolderSection = css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;

    .gm-style-iw-c {
        ${borderRadius()};
        ${elevation(0)};
        padding-right: 15px !important;
        button {
            top: 3px;
            right: 3px;
            display: none !important;
        }
    }
`;

const mapHolder = css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
`;

const mapModalButton = css`
    position: absolute;
    top: 2.5rem;
    left: 2.5rem;
    z-index: 1;
`;

const elementIndex = css`
    z-index: 1;
`;

const mapOfferSidebarWrapper = css`
    ${pt(2)};
`;
